// extracted by mini-css-extract-plugin
export var bounce = "component-module--bounce--01711";
export var cookieGroupContent = "component-module--cookieGroupContent--8ba07";
export var cookieGroupWrapper = "component-module--cookieGroupWrapper--4f4cd";
export var fadeIn = "component-module--fadeIn--65ba6";